import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateKeyValueRequest } from '@models/base/createKeyValueRequest.model';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { UpdateKeyValueRequest } from '@models/base/updateKeyValueRequest.model';
import { CreateExpedienteNotaRequest } from '@models/expedienteNota/createExpedienteNotaRequest.model';
import { ExpedienteNotaDto } from '@models/expedienteNota/expedienteNotaDto.model';
import { UpdateExpedienteNotaRequest } from '@models/expedienteNota/updateExpedienteNotaRequest.model';
import { ExpedienteParteDto } from '@models/expedienteParte/expedienteParteDto.model';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';

@Injectable({
  providedIn: 'root'
})
export class JuridiccionService {

  constructor(
    private http:HttpClient
  ) { }

  create(createKeyValueRequest:CreateKeyValueRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/Jurisdiccion/Create",createKeyValueRequest);
  }

  update(updateKeyValueRequest:UpdateKeyValueRequest):Observable<any>
  {
    return  this.http.put<any>("/api/Jurisdiccion/Update",updateKeyValueRequest);
  }

  getAll():Observable<BaseDto[]> {
    return   this.http.get<BaseDto[]>("/api/Jurisdiccion/GetAll");
  }

  getById(id:number):Observable<BaseDto>{
    return  this.http.get<BaseDto>("/api/Jurisdiccion/GetById?id="+id);
  }

   getAllByIdProvincia(idProvincia:number):Observable<BaseDto>{
    return  this.http.get<BaseDto>("/api/Jurisdiccion/GetAllByIdProvincia?idProvincia="+idProvincia);
  }


  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/Jurisdiccion/Delete?id=" + id);
    else
      return of(null)
  }
}
